// Canada number formatter (same behavior as iOS NumberFormatter)
// const caNumberFormatter = new Intl.NumberFormat("en-CA", {
//   maximumFractionDigits: 0, // same as .decimal without decimals
// });

// export const formatNumberCA = (value) => {
//   if (value === null || value === undefined || isNaN(value)) return "0";
//   return caNumberFormatter.format(Number(value));
// };




// const caNumberFormatter = new Intl.NumberFormat("en-CA", {
//   useGrouping: true,
//   minimumFractionDigits: 0,
//   maximumFractionDigits: 0,
// });

// utils/numberFormat.js

export const formatNumberCA = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "0";

  return Number(value)
    .toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

